import React, { useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

import { ModalConfirmationStyle, WrapperButtonsModal, ButtonModal } from './style'

type ICourses = {
  courseName: string
}

type ModalConfirmationProps = React.FC<{
  onSubmit: () => void
  setPreConfirmed: React.Dispatch<React.SetStateAction<boolean>>
  courses: ICourses[]
  email: string
  phone: string
  name: string
  cpf: string
}>

export const ModalConfirmation: ModalConfirmationProps = ({
  onSubmit,
  setPreConfirmed,
  courses,
  email,
  phone,
  name,
  cpf
}) => {
  const [isValidateCaptcha, setIsValidateCaptcha] = useState(false)
  const validateCaptcha = () => {
    setIsValidateCaptcha(true)
  }

  const expiredCaptcha = () => {
    setIsValidateCaptcha(false)
  }
  return (
    <ModalConfirmationStyle>
      <section>
        <h3>Verifique os seus dados para enviar o seu pré-cadastro!</h3>
        <p>Nome completo: {name}</p>
        <p>CPF: {cpf}</p>
        <p>E-mail: {email}</p>
        <p>Celular: +55 {phone}</p>
        <p>Curso(s) selecionado:</p>
        {courses.map((course, index) => (
          <p key={index + 1}>{course.courseName}</p>
        ))}
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY as string}
          onChange={validateCaptcha}
          onExpired={expiredCaptcha}
        />
        <WrapperButtonsModal>
          <ButtonModal typeButton={1} onClick={() => setPreConfirmed(false)}>
            Editar dados
          </ButtonModal>
          <ButtonModal typeButton={2} onClick={onSubmit} disabled={!isValidateCaptcha}>
            Enviar
          </ButtonModal>
        </WrapperButtonsModal>
      </section>
    </ModalConfirmationStyle>
  )
}
